/* eslint-disable max-len */
/* eslint-disable no-tabs */
import React, { ReactElement } from 'react';
import { Link, Typography } from '@material-ui/core';
import { getHomeLink } from 'utils/navigateHome';

const Legal = (): ReactElement => (
  <>
    <Typography variant="h1">Legal notice</Typography>

    <Typography variant="body1">
      To read more about the Refinery Optimizers terms and conditions go to{' '}
      <Link href={getHomeLink('legal')}>Legal notice</Link>
    </Typography>
  </>
);

export default Legal;
